import { AbilityAction, AbilitySubject } from "@/enums/enums";
import { EmployeePermissionModel } from "@/model/user/ApplicationPermissionModel";

export function DefineEmployeePermissionAbility(employeePermission: EmployeePermissionModel, can: any) {
  const { information, report } = employeePermission ?? {};

  information?.view && can(AbilityAction.Access, AbilitySubject.ViewEmployee);
  information?.create && can(AbilityAction.Create, AbilitySubject.CreateEmployee);
  information?.edit && can(AbilityAction.Update, AbilitySubject.EditEmployee);
  information?.delete && can(AbilityAction.Update, AbilitySubject.DeleteEmployee);

  report?.print && can(AbilityAction.Create, AbilitySubject.ExportEmployee);
}
